import { useEffect, useState } from "react";
import { InputQuantity } from "../../components/InputQuantity";
import { useCheckoutStore } from "../../store/checkoutStore";
import { getVariantsByIds, Variant } from "../../services/getVariant";
import {
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { colorDoubleMap } from "../../helpers/Colors";
import {
  buildLayeredBackground,
  cleanColorName,
  isUrl,
  toColor,
} from "../../utils/funtions";
import { ArrowSplideLeft, TrashCan } from "../../icons";
import GrishaEmpty from "../../assets/grisha-empty.png";
import { SumaryOrder } from "../../components/SumaryOrder";
import { createCart } from "../../services/checkout";
import { useNavigate } from "react-router-dom";

export const Check = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const variants = useCheckoutStore((state) => state.variants);
  const updateQuantity = useCheckoutStore((state) => state.updateQuantity);
  const variantIds = variants.map((v) => v.variants);
  const quantities = variants.map((q) => q.qty);

  const { removeVariant } = useCheckoutStore();

  const [dataVariant, setDataVariant] = useState<Variant[]>([]);
  const TotalGeneral = variants.reduce((total, item) => {
    const amount = parseInt(item.amount) || 0;
    return total + item.qty * amount;
  }, 0);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const getVariant = async () => {
      const data = await getVariantsByIds(variantIds);
      setDataVariant(data);
    };
    getVariant();
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
  const onCheckout = async () => {
    const cart = await createCart(variantIds, quantities);
    if (cart?.checkoutUrl) {
      window.location.href = cart.checkoutUrl;
    }
  };
  return (
    <Fade in timeout={1000}>
      <Box>
        <Grid marginInline={{ xs: 3, md: 10 }} mt={10} container spacing={5}>
          <Grid display="flex" justifyContent="space-between" alignItems="center" size={12} marginInline={2}>
            <Typography variant="h4">Checkout</Typography>

          </Grid>
          <Grid borderRadius={4} size={{ xs: 12, md: 9 }}>
            <TableContainer
              sx={{
                boxShadow: `${theme.palette.customColor?.light} 0px 0px 3px`,
                borderRadius: 4,
              }}
              elevation={0}
              component={Paper}
            >
              <Box flex={1} display="flex" gap={1} p={4} alignItems="center">
                <Typography color="secondary" variant="h6">
                  Cart
                </Typography>
                <Typography
                  fontSize={16}
                  sx={{ color: theme.palette.secondary[100] }}
                >
                  ({variants.reduce((acc, q) => acc + q.qty, 0)} items)
                </Typography>
              </Box>
              {variants.length <= 0 ? (
                <Box
                  width="100%"
                  minHeight={290}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  gap={3}
                >
                  <Fade in timeout={2000}>
                    <Box
                      width={{ xs: 140, md: 180 }}
                      height={{ xs: 70, md: 90 }}
                    >
                      <img
                        width="100%"
                        height="100%"
                        src={GrishaEmpty}
                        loading="lazy"
                        alt="GrishaEmpty"
                      />
                    </Box>
                  </Fade>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: theme.palette.secondary[100] }}
                    >
                      Cart is empty!
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: theme.palette.secondary[100] }}
                    >
                      Looks like you have no items in your shopping cart
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Table>
                  <TableHead
                    sx={{ backgroundColor: theme.palette.customColor?.main }}
                  >
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        sx={{
                          textTransform: "uppercase",
                          color: theme.palette.secondary[500],
                          fontWeight: 600,
                        }}
                      >
                        Product
                      </TableCell>
                      <TableCell
                        sx={{
                          textTransform: "uppercase",
                          color: theme.palette.secondary[500],
                          fontWeight: 600,
                        }}
                        align="center"
                      >
                        Price
                      </TableCell>
                      <TableCell
                        sx={{
                          textTransform: "uppercase",
                          color: theme.palette.secondary[500],
                          fontWeight: 600,
                        }}
                        align="center"
                      >
                        Quantity
                      </TableCell>
                      <TableCell
                        sx={{
                          textTransform: "uppercase",
                          color: theme.palette.secondary[500],
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        Total price
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {dataVariant.flatMap((v) =>
                      variants
                        .filter((c) => String(c.variants) === String(v.id))
                        .map((c) => (
                          <TableRow
                            key={`${String(v.id)}-${String(c.variants)}`}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={v.image.url}
                                  width={85}
                                  height={95}
                                  style={{
                                    borderRadius: 10,
                                    objectFit: "cover",
                                  }}
                                  alt={v.image.altText ?? ""}
                                />
                                <Box
                                  display="flex"
                                  flex={1}
                                  gap={2}
                                  flexDirection="column"
                                >
                                  <Typography
                                    variant="body1"
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                    fontWeight={500}
                                    width="70%"
                                  >
                                    {v.product.title}
                                  </Typography>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    flexWrap="nowrap"
                                    alignItems="center"
                                    gap={2}
                                  >
                                    {v.selectedOptions.map((op, i) => {
                                      const name = cleanColorName(
                                        op.value
                                      ).replace(/[\s/]+/g, "");
                                      const isSlash = op.value.includes("/");
                                      let stops: string[] = [];
                                      if (isSlash) {
                                        const arr = colorDoubleMap[name] ?? [
                                          "blue",
                                          "red",
                                        ];

                                        stops = Array.isArray(arr)
                                          ? arr.slice(0, 3)
                                          : ["blue", "red"];
                                      } else {
                                        if (isUrl(name)) stops = [name];
                                        else stops = [toColor(name)];
                                      }
                                      const bg = buildLayeredBackground(stops);
                                      return (
                                        <Box key={i}>
                                          {op.name === "Color" ? (
                                            <Box
                                              display="flex"
                                              gap={1}
                                              alignItems="center"
                                              p={1}
                                              sx={{
                                                boxShadow: `0px 0px 0px 1px ${theme.palette.brand?.main}`,
                                                borderRadius: 1,
                                                backgroundColor:
                                                  theme.palette.brand?.main,
                                              }}
                                            >
                                              <Typography variant="body2">
                                                {op.name}
                                              </Typography>
                                              <Divider
                                                orientation="vertical"
                                                variant="fullWidth"
                                                flexItem
                                                sx={{
                                                  borderColor:
                                                    theme.palette.customColor
                                                      ?.light,
                                                }}
                                              />
                                              <Tooltip title={op.value}>
                                                <Box
                                                  sx={{
                                                    boxShadow:
                                                      "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                                    minWidth: 20,
                                                    minHeight: 20,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius:
                                                      "5px !important",
                                                    objectFit: "cover",
                                                    backgroundPosition:
                                                      "center",
                                                    backgroundSize: "cover",
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    ...(bg.backgroundImage
                                                      ? {
                                                          backgroundImage:
                                                            bg.backgroundImage,
                                                        }
                                                      : {}),
                                                    ...(bg.backgroundColor
                                                      ? {
                                                          backgroundColor:
                                                            bg.backgroundColor,
                                                        }
                                                      : {}),
                                                  }}
                                                />
                                              </Tooltip>
                                            </Box>
                                          ) : (
                                            <Box
                                              display={
                                                op.name === "Title"
                                                  ? "none"
                                                  : "flex"
                                              }
                                              gap={1}
                                              alignItems="center"
                                              p={1}
                                              sx={{
                                                boxShadow: `0px 0px 0px 1px ${theme.palette.brand?.main}`,
                                                borderRadius: 1,
                                                backgroundColor:
                                                  theme.palette.brand?.main,
                                              }}
                                            >
                                              <Typography variant="body2">
                                                {op.name === "Title"
                                                  ? ""
                                                  : op.name}
                                              </Typography>
                                              <Divider
                                                orientation="vertical"
                                                variant="fullWidth"
                                                flexItem
                                                sx={{
                                                  borderColor:
                                                    theme.palette.customColor
                                                      ?.light,
                                                }}
                                              />
                                              <Typography
                                                variant="body2"
                                                whiteSpace="nowrap"
                                              >
                                                {op.value === "Default Title"
                                                  ? ""
                                                  : op.value}
                                              </Typography>
                                            </Box>
                                          )}
                                        </Box>
                                      );
                                    })}
                                  </Box>
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell align="center">
                              <Typography variant="body1">
                                ${c.amount}
                              </Typography>
                            </TableCell>

                            <TableCell align="center">
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Box
                                  display="flex"
                                  alignItems="flex-end"
                                  flexDirection="column"
                                  gap={1}
                                >
                                  <InputQuantity
                                    available={c.available}
                                    quantity={c.qty ?? 0}
                                    setQuantity={(n) =>
                                      updateQuantity(c.variants, n)
                                    }
                                  />

                                  <Typography
                                    sx={{
                                      color:
                                        c.available > 0
                                          ? theme.palette.success.main
                                          : theme.palette.warning.main,
                                    }}
                                    variant="caption"
                                  >
                                    Available: {c.available}
                                  </Typography>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Typography variant="body1">
                                $
                                {(c.qty * c.amount).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <IconButton onClick={() => removeVariant(v.id)}>
                                <TrashCan sx={{ width: 18, height: 18 }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            <Button
              onClick={() => navigate(-2)}
              size="small"
              disableElevation
              sx={{
                marginBlock: 4,
                backgroundColor: theme.palette.common.white,
              }}
              variant="contained"
              startIcon={<ArrowSplideLeft sx={{ width: 13, height: 13 }} />}
            >
              Continue shopping
            </Button>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <SumaryOrder
              onClick={onCheckout}
              variants={variants}
              total={TotalGeneral}
            />
          </Grid>
        </Grid>
      </Box>
    </Fade>
  );
};
